export const fn_ValidateIBAN = (IBAN) => {
  //Se pasa a Mayusculas
  let IBAN_ = IBAN.toUpperCase();
  //Se quita los blancos de principio y final.
  IBAN_ = IBAN_.trim();
  IBAN_ = IBAN_.replace(/\s/g, ""); //Y se quita los espacios en blanco dentro de la cadena

  let letra1, letra2, num1, num2;
  let isbanaux;
  //let numeroSustitucion;
  //La longitud debe ser siempre de 24 caracteres
  if (IBAN_.length != 24) {
    return false;
  }

  // Se coge las primeras dos letras y se pasan a números
  letra1 = IBAN_.substring(0, 1);
  letra2 = IBAN_.substring(1, 2);
  num1 = getnumIBAN(letra1);
  num2 = getnumIBAN(letra2);
  //Se sustituye las letras por números.
  isbanaux = String(num1) + String(num2) + IBAN_.substring(2);
  // Se mueve los 6 primeros caracteres al final de la cadena.
  isbanaux = isbanaux.substring(6) + isbanaux.substring(0, 6);

  //Se calcula el resto, llamando a la función modulo97, definida más abajo
  const resto = modulo97(isbanaux);
  if (resto == 1) {
    return true;
  } else {
    return false;
  }
};

const modulo97 = (iban) => {
  let parts = Math.ceil(iban.length / 7);
  let remainer = "";

  for (let i = 1; i <= parts; i++) {
    remainer = String(parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97);
  }

  return remainer;
};

const getnumIBAN = (letra) => {
  let ls_letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  return ls_letras.search(letra) + 10;
};

/////////////////////////////////////////////

/*
 * Validador de CIF mejorado para incluir Sociedades Civiles (J)
 * Tiene que recibir el cif sin espacios ni guiones
 */

export const validateCIF = (cif) => {
  // Verificar longitud
  if (cif.length !== 9) {
    return false;
  }
  
  // Quitamos el primer caracter y el ultimo digito
  let valueCif = cif.substr(1, cif.length - 2);

  let suma = 0;

  // Sumamos las cifras pares de la cadena
  for (let i = 1; i < valueCif.length; i = i + 2) {
    suma = suma + parseInt(valueCif.substr(i, 1));
  }

  let suma2 = 0;

  // Sumamos las cifras impares de la cadena
  for (let i = 0; i < valueCif.length; i = i + 2) {
    let result = parseInt(valueCif.substr(i, 1)) * 2;
    if (String(result).length == 1) {
      // Un solo caracter
      suma2 = suma2 + parseInt(result);
    } else {
      // Dos caracteres. Los sumamos...
      suma2 =
        suma2 +
        parseInt(String(result).substr(0, 1)) +
        parseInt(String(result).substr(1, 1));
    }
  }

  // Sumamos las dos sumas que hemos realizado
  suma = suma + suma2;

  let unidad = suma % 10;
  unidad = 10 - unidad;
  if (unidad === 10) unidad = 0;

  let primerCaracter = cif.substr(0, 1).toUpperCase();

  // Tratamiento especial para J (Sociedades Civiles): puede ser número o letra
  if (primerCaracter === 'J') {
    let ultimoCaracter = cif.substr(cif.length - 1, 1);
    
    // Intentar validación como número
    if (/^\d$/.test(ultimoCaracter)) {
      return parseInt(ultimoCaracter) === unidad;
    }
    
    // Intentar validación como letra
    if (/^[A-Z]$/i.test(ultimoCaracter)) {
      return String.fromCharCode(64 + unidad).toUpperCase() === ultimoCaracter.toUpperCase();
    }
    
    return false;
  }

  if (primerCaracter.match(/^[FKNPQRSUVW]$/)) {
    // Empieza por .... Comparamos la ultima letra
    if (
      String.fromCharacter(64 + unidad).toUpperCase() ==
      cif.substr(cif.length - 1, 1).toUpperCase()
    )
      return true;
  } else if (primerCaracter.match(/^[XYZ]$/)) {
    // Se valida como un dni
    let newcif;
    if (primerCaracter == "X") newcif = cif.substr(1);
    else if (primerCaracter == "Y") newcif = "1" + cif.substr(1);
    else if (primerCaracter == "Z") newcif = "2" + cif.substr(1);
    return validateDNI(newcif);
  } else if (primerCaracter.match(/^[ABCDEFGHLM]$/)) {
    // Se revisa que el ultimo valor coincida con el calculo
    if (cif.substr(cif.length - 1, 1) == String(unidad)) return true;
  } else {
    // Se valida como un dni
    return validateDNI(cif);
  }
  return false;
};

/*
 * Tiene que recibir el dni sin espacios ni guiones
 * Esta funcion es llamada
 */
function validateDNI(dni) {
  const lookup = "TRWAGMYFPDXBNJZSQVHLCKE";
  const valueDni = dni.slice(0, -1); // más moderno que substr
  const letra = dni.slice(-1).toUpperCase();

  return lookup.charAt(valueDni % 23) === letra;
}

//Calcular BIC
export const calculateBIC = (entity) => {
  let bic = [];

  bic[3] = "BDEPESM1XXX";
  bic[30] = "ESPCESMMXXX";
  bic[31] = "ETCHES2GXXX";
  bic[36] = "SABNESMMXXX";
  bic[46] = "GALEES2GXXX";
  bic[49] = "BSCHESMMXXX";
  bic[57] = "BVADESMMXXX";
  bic[58] = "BNPAESMMXXX";
  bic[59] = "MADRESMMXXX";
  bic[61] = "BMARES2MXXX";
  bic[65] = "BARCESMMXXX";
  bic[73] = "OPENESMMXXX";
  bic[75] = "POPUESMMXXX";
  bic[78] = "BAPUES22XXX";
  bic[81] = "BSABESBBXXX";
  bic[83] = "RENBESMMXXX";
  bic[86] = "NORTESMMXXX";
  bic[94] = "BVALESMMXXX";
  bic[122] = "CITIES2XXXX";
  bic[125] = "BAOFESM1XXX";
  bic[128] = "BKBKESMMXXX";
  bic[130] = "CGDIESMMXXX";
  bic[133] = "MIKBESB1XXX";
  bic[136] = "AREBESMMXXX";
  bic[138] = "BKOAES22XXX";
  bic[149] = "BNPAESMSXXX";
  bic[167] = "GEBAESMMXXX";
  bic[182] = "BBVAESMMXXX";
  bic[184] = "BEDFESM1XXX";
  bic[186] = "BFIVESBBXXX";
  bic[188] = "ALCLESMMXXX";
  bic[190] = "BBPIESMMXXX";
  bic[196] = "WELAESMMXXX";
  bic[198] = "BCOEESMMXXX";
  bic[200] = "PRVBESB1XXX";
  bic[211] = "PROAESMMXXX";
  bic[216] = "POHIESMMXXX";
  bic[219] = "BMCEESMMXXX";
  bic[220] = "FIOFESM1XXX";
  bic[224] = "SCFBESMMXXX";
  bic[227] = "UNOEESM1XXX";
  bic[229] = "POPLESMMXXX";
  bic[231] = "DSBLESMMXXX";
  bic[232] = "INVLESMMXXX";
  bic[233] = "POPIESMMXXX";
  bic[234] = "CCOCESMMXXX";
  bic[235] = "PICHESMMXXX";
  bic[236] = "LOYIESMMXXX";
  bic[237] = "CSURES2CXXX";
  bic[238] = "PSTRESMMXXX";
  bic[239] = "EVOBESMMXXX";
  bic[487] = "GBMNESMMXXX";
  bic[1459] = "PRABESMMXXX";
  bic[1460] = "CRESESMMXXX";
  bic[1465] = "INGDESMMXXX";
  bic[1474] = "CITIESMXXXX";
  bic[1475] = "CCSEESM1XXX";
  bic[1490] = "SELFESMMXXX";
  bic[1491] = "TRIOESMMXXX";
  bic[1524] = "UBIBESMMXXX";
  bic[1525] = "BCDMESMMXXX";
  bic[1534] = "KBLXESMMXXX";
  bic[1544] = "BACAESMMXXX";
  bic[2000] = "CECAESMMXXX";
  bic[2013] = "CESCESBBXXX";
  bic[2031] = "CECAESMM031";
  bic[2038] = "CAHMESMMXXX";
  bic[2043] = "CECAESMM043";
  bic[2045] = "CECAESMM045";
  bic[2048] = "CECAESMM048";
  bic[2051] = "CECAESMM051";
  bic[2056] = "CECAESMM056";
  bic[2066] = "CECAESMM066";
  bic[2080] = "CAGLESMMXXX";
  bic[2085] = "CAZRES2ZXXX";
  bic[2086] = "CECAESMM086";
  bic[2095] = "BASKES2BXXX";
  bic[2096] = "CSPAES2LXXX";
  bic[2099] = "CECAESMM099";
  bic[2100] = "CAIXESBBXXX";
  bic[2103] = "UCJAES2MXXX";
  bic[2104] = "CSSOES2SXXX";
  bic[2105] = "CECAESMM105";
  bic[3001] = "BCOEESMM001";
  bic[3005] = "BCOEESMM005";
  bic[3007] = "BCOEESMM007";
  bic[3008] = "BCOEESMM008";
  bic[3009] = "BCOEESMM009";
  bic[3016] = "BCOEESMM016";
  bic[3017] = "BCOEESMM017";
  bic[3018] = "BCOEESMM018";
  bic[3020] = "BCOEESMM020";
  bic[3023] = "BCOEESMM023";
  bic[3025] = "CDENESBBXXX";
  bic[3029] = "CCRIES2A029";
  bic[3035] = "CLPEES2MXXX";
  bic[3045] = "CCRIES2A045";
  bic[3058] = "CCRIES2AXXX";
  bic[3059] = "BCOEESMM059";
  bic[3060] = "BCOEESMM060";
  bic[3063] = "BCOEESMM063";
  bic[3067] = "BCOEESMM067";
  bic[3070] = "BCOEESMM070";
  bic[3076] = "BCOEESMM076";
  bic[3080] = "BCOEESMM080";
  bic[3081] = "BCOEESMM081";
  bic[3084] = "CVRVES2BXXX";
  bic[3085] = "BCOEESMM085";
  bic[3089] = "BCOEESMM089";
  bic[3095] = "CCRIES2A095";
  bic[3096] = "BCOEESMM096";
  bic[3098] = "BCOEESMM098";
  bic[3102] = "BCOEESMM102";
  bic[3104] = "BCOEESMM104";
  bic[3105] = "CCRIES2A105";
  bic[3110] = "BCOEESMM110";
  bic[3111] = "BCOEESMM111";
  bic[3112] = "CCRIES2A112";
  bic[3113] = "BCOEESMM113";
  bic[3115] = "BCOEESMM115";
  bic[3116] = "BCOEESMM116";
  bic[3117] = "BCOEESMM117";
  bic[3118] = "CCRIES2A118";
  bic[3119] = "CCRIES2A119";
  bic[3121] = "CCRIES2A121";
  bic[3123] = "CCRIES2A123";
  bic[3127] = "BCOEESMM127";
  bic[3130] = "BCOEESMM130";
  bic[3134] = "BCOEESMM134";
  bic[3135] = "CCRIES2A135";
  bic[3138] = "BCOEESMM138";
  bic[3140] = "BCOEESMM140";
  bic[3144] = "BCOEESMM144";
  bic[3146] = "CCCVESM1XXX";
  bic[3150] = "BCOEESMM150";
  bic[3152] = "CCRIES2A152";
  bic[3157] = "CCRIES2A157";
  bic[3159] = "BCOEESMM159";
  bic[3160] = "CCRIES2A160";
  bic[3162] = "BCOEESMM162";
  bic[3165] = "CCRIES2A165";
  bic[3166] = "BCOEESMM166";
  bic[3174] = "BCOEESMM174";
  bic[3179] = "CCRIES2A179";
  bic[3183] = "CASDESBBXXX";
  bic[3186] = "CCRIES2A186";
  bic[3187] = "BCOEESMM187";
  bic[3190] = "BCOEESMM190";
  bic[3191] = "BCOEESMM191";
  bic[9000] = "ESPBESMMXXX";

  return bic[entity * 1];
};

export const messageVaidate = (title, errors) => {
  const messages = [
    {
      alert: "VALUE_MUST_NOT_BE_EMPTY",
      api_msg: "Required value in request",
      traduction_es: "El compo es oblgatorio",
    },
    {
      alert: "VALUE_NOT_IN_RANGE",
      api_msg: "Required amount in request",
      traduction_es: "el monto es obligatorio",
    },
    {
      alert: "ID_ZERO",
      api_msg: "Required ID(int) in request",
      traduction_es: "EL id(int) es requerido",
    },
    {
      alert: "ADDRESS_PROVINCE_INVALID",
      api_msg: "CountryId != 'ES' and ProvinceId !='99' ('Países extranjeros')",
      traduction_es: "EL id(int) es requerido",
    },
    {
      alert: "ADDRESS_ALLOWED_UPDATE_PERIOD_EXPIRED",
      api_msg: "Update an address on a different date than creation date",
      traduction_es:
        "No se puede dactualizar la dirección (solo es permitido el mismo día de creación)",
    },
    {
      alert: "BANKACCOUNT_FORMAT_LENGTH_ERROR",
      api_msg: "Length of BankAccount < 24",
      traduction_es: "La cuenta bancaria debe contener mínimo 24 dígitos",
    },
    {
      alert: "BANKACCOUNT_FORMAT_IBAN_ERROR",
      api_msg: "Incorrect format of bankAccount (control digit)",
      traduction_es: "EL formato de la cuenta bancaria es incorrecto",
    },
    {
      alert: "BANKACCOUNT_FORMAT_TENANT_ERROR",
      api_msg:
        "Format of BankAccount does not match with BankAccountPrefix andBankAccountCountryPrefix in DB (SME.Tenants)",
      traduction_es:
        "El formato de la cuenta bancaria no coincide con BankAccountPrefix y BankAccountCountryPrefix en DB ",
    },
    {
      alert: "FORBIDDEN",
      api_msg: "Client has no authorization",
      traduction_es: "Acción no permitida, verifique su sesión",
    },
    {
      alert: "SUBSCRIPTION_EXPIRED",
      api_msg: "Client has no access",
      traduction_es: "Acceso no permitido",
    },
    {
      alert: "CLIENT_NOTFOUND",
      api_msg: "Requested client not found",
      traduction_es: "Cliente solicitado no encontrado",
    },
    {
      alert: "CLIENT_ALREADY_CONFIRMED",
      api_msg: "Client already confirmed",
      traduction_es: "Cliente ya ha sido confirmado",
    },
    {
      alert: "CLIENT_ALREADY_REJECTED",
      api_msg: "Client already rejected",
      traduction_es: "Cliente ya ha sido rechazada",
    },
    {
      alert: "CLIENT_ALREADY_EXISTS",
      api_msg: "Client(CIF) already exists in DB",
      traduction_es: "EL CIF ya existe",
    },
    {
      alert: "CLIENT_ALREADY_CREATED",
      api_msg: "Client already exists in collection system",
      traduction_es: "El cliente ya existe en el sistema de cobro",
    },
    {
      alert: "SUBSCRIPTION_ALREADY_CANCELLED",
      api_msg: "Subscription already cancelled",
      traduction_es: "La suscripción ya ha sido cancelada",
    },
    {
      alert: "CONTRACT_NOTFOUND",
      api_msg: "Contract not found",
      traduction_es: "Contrato no encontrado",
    },
    {
      alert: "CONTRACT_CLIENT_NOTFOUND",
      api_msg: "Requested client not found",
      traduction_es: "Cliente solicitado no encontrado",
    },
    {
      alert: "EMAIL_FORMAT_ERROR ",
      api_msg: "Email format (regex) error",
      traduction_es: "Fromato de email no válido ()",
    },
    {
      alert: "EMAIL_ALLOWED_UPDATE_PERIOD_EXPIRED",
      api_msg: "Update an email on a different date than creation date ",
      traduction_es:
        "no se puede modificar correo electrónico en una fecha diferente a la fecha de creación",
    },
    {
      alert: "INVOICE_NOTFOUND ",
      api_msg: "Invoice not found",
      traduction_es: "Factura no encontrada",
    },
    {
      alert: "LOGIN_WRONG_CREDENTIALS",
      api_msg:
        "Wrong password, Invalid user or invalid current password request, Invalid credentials or authToken, Invalid credentials",
      traduction_es:
        "Contraseña incorrecta, Usuario no válido o solicitud de contraseña actual no válida, Credenciales o authToken no válidos, Credenciales no válidas",
    },
    {
      alert: "PASSWORD_FORMAT_ERROR_NOTUPPERCASE",
      api_msg: "Required",
      traduction_es:
        "La contraseña debe contener mínimo 8 caracteres, al menos una letra minúscula, al menos una letra mayúscula y al menos un número.",
    },
    {
      alert: "USER_EMAIL_FORMAT_ERROR",
      api_msg: "Required",
      traduction_es: "Formato de email incorrecto (ej: email@dominio.com)",
    },
    {
      alert:
        "The JSON value could not be converted to System.Nullable`1[System.Decimal]. Path: $.amount",
      api_msg: "Error amount",
      traduction_es: "Monto incorrecto",
    },
    {
      alert: "INVALID_CODE",
      api_msg: "INVALID_CODE",
      traduction_es: "Código de contrato inválido",
    },
    {
      alert: "NOTSIGNED",
      api_msg: "NOTSIGNED",
      traduction_es: "Contrato no firmado",
    },
    {
      alert: "USER_INVALID_OR_EXPIRED_CODE",
      api_msg: "USER_INVALID_OR_EXPIRED_CODE",
      traduction_es: "el código es inválido o ha expirado",
    },
    {
      alert: "INCORRECT_TENANTID",
      api_msg: "INCORRECT_TENANTID",
      traduction_es: "Tenant Incorrecto",
    },
    {
      alert: "CLIENT_ALREADY_CONFIRMED",
      api_msg: "CLIENT_ALREADY_CONFIRMED",
      traduction_es: "Este cliente ya ha sido conformado",
    },
  ];

  let error_ = [];

  if (errors && !isObject(errors)) {
    error_ = messages.filter((msg) => msg.alert === title);
  } else {
    let arr_err = [];
    for (let i in errors) {
      console.log(errors[i]);
      errors[i].map((error) => {
        arr_err.push(messages.filter((msg) => error.indexOf(msg.alert) === 0));
      });

      arr_err.map((arrays_msg) => {
        arrays_msg.map((array_msg) => {
          error_.push(array_msg);
        });
      });
    }
  }

  return error_;
};

export const isObject = (value) => {
  return value instanceof Object;
};

export const form_reg_email = (value) => {
  const re_email = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const ok = re_email.exec(value);
  let field_ = "";

  if (!ok) {
    field_ = `${value} no es un email válido!`;
  }

  return field_;
};

export const form_reg_numbers = (value) => {
  const re_email = /^\d+$/;
  const ok = re_email.exec(value);
  let field_ = "";

  if (!ok) {
    field_ = `${value} no es un número válido!`;
  }

  return field_;
};

export const form_reg_amount = (value) => {
  const re_email = /[\d,.]+/; //^[0-9]{1,3}([\\.][0-9]{3})/;
  const ok = re_email.exec(value);
  let field_ = "";

  if (!ok) {
    field_ = `${value} no es un monto válido!`;
  }

  return field_;
};

export const getParamUrl = (variable) => {
  let params = new URLSearchParams(location.search);
  let param = params.get(variable);
  return param;
};

export const downloadBlob = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    let elem = window.document.createElement("a");
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
};

export const downloadDocument = (strBase64, filename) => {
  let url = "data:application/msword;base64," + strBase64;
  ///let documento = null;
  fetch(url)
    .then((res) => res.blob())
    .then(function (blob) {
      downloadBlob(blob, filename);
    });
};
